// plugins/auth-init.client.ts
// Hydratation MSAL différée sur la home pour ne pas impacter le LCP.

import type { PublicClientApplication } from '@azure/msal-browser'
import { peekMsalOAuthPending } from '~/utils/msalOAuthSession'
import { enrichPostHogProfil } from '~/composables/useTracking'
import { hydrateUserStoreFromMsalIfNeeded } from '~/utils/msalUtils'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()

  const runAuthInit = async (): Promise<void> => {
    await router.isReady()

    const msal = (await nuxtApp.$msalReady) as PublicClientApplication | null
    if (msal) {
      try {
        await msal.handleRedirectPromise()
      } catch {
        // Retour OAuth / logout : ignorer et continuer l'init.
      }
    }

    const userStore = useUserStore()
    const route = router.currentRoute.value
    if (!userStore.isLoggedIn && route.path === '/' && typeof route.query.state === 'string') {
      await router.replace({ path: '/' })
      return
    }

    await hydrateUserStoreFromMsalIfNeeded()
    if (userStore.userId) void enrichPostHogProfil(userStore.userId)
  }

  const scheduleAuthInit = (): void => {
    const route = router.currentRoute.value
    const isHome = route.path === '/' || route.path === '/fr'
    const hasOAuthHint =
      typeof route.query.state === 'string' ||
      typeof route.query.code === 'string' ||
      peekMsalOAuthPending()

    const start = (): void => {
      void runAuthInit()
    }

    if (isHome && !hasOAuthHint) {
      const afterLoad = (): void => {
        if (typeof requestIdleCallback === 'function') {
          requestIdleCallback(start, { timeout: 8000 })
        } else {
          setTimeout(start, 4000)
        }
      }
      if (document.readyState === 'complete') {
        afterLoad()
      } else {
        window.addEventListener('load', afterLoad, { once: true })
      }
      return
    }

    void runAuthInit()
  }

  nuxtApp.hook('app:mounted', scheduleAuthInit)
})
